import { type Components, type Theme } from '@mui/material';

export const MuiDrawer: Components<Theme>['MuiDrawer'] = {
  styleOverrides: {
    paper: {
      overflow: 'inherit',
    },
  },
};
